import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// ANT DESIGN IMPORTS
import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Statistic,
  Typography,
} from "antd";

// PROJECT IMPORTS
import styles from "../../../../../../assets/styles/styles";
import { rightAction } from "../../../../../../redux/actions";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";

const SearchJournalEntry = (props) => {
  const {
    userData,
    rightBtn,
    rightAction,
    currentAccountObj,
    setJournalEntryList,
    setOriginalList,
  } = props;
  const { RangePicker } = DatePicker;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountData, setAccountData] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [showSearch, setShowSearch] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    {
      BOM.HasPermission("READ_JOURNALENTRY") && getOffice();
    }
    {
      BOM.HasPermission("READ_JOURNALENTRY") && getGlAccount();
    }
  }, []);

  function getOffice() {
    const url = `${apiConfig.Offices}`;

    let body = {
      session,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempArray);
      }
      setIsLoading(false);
    });
  }

  function getGlAccount() {
    const params = {
      disabled: false,
      usage: 1,
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, apiConfig.GlAccounts, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            value: element.id,
            label: element.name,
          });
        });

        setAccountData(tempArray);
      }
      setIsLoading(false);
    });
  }

  const onSubmit = (formValues) => {
    formValues.fromDate = formValues.date
      ? BOM.DateTime(formValues.date[0], "only-date")
      : null;

    formValues.toDate = formValues.date
      ? BOM.DateTime(formValues.date[1], "only-date")
      : null;

    // console.log(formValues);
    // return;
    const params = {
      dateFormat: "dd MMMM yyyy",
      fromDate: formValues.fromDate,
      glAccountId: formValues.glAccountId,
      limit: 14,
      locale: "en",
      manualEntriesOnly: formValues.manualEntriesOnly,
      officeId: formValues.officeId,
      offset: 0,
      toDate: formValues.toDate,
      transactionId: formValues.transactionId,
    };

    const url = `${apiConfig.JournalEntries}`;
    const body = {
      ...formValues,
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            branch: element?.officeName ? element?.officeName : "-",
            transactionDate: element?.transactionDate
              ? BOM.FormatArrayDate(element?.transactionDate)
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            type: element?.glAccountType?.value
              ? element?.glAccountType?.value
              : "-",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                  ? "Cr"
                  : "-"
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
            amountToUse: element?.amount ? element?.amount : 0,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setJournalEntryList(tempArray.filter((item) => item.disabled === false));
        setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        // setOriginalList(tempArray);

        // close modal
        setIsModalOpen(false);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Button
        type="primary"
        className="of-primaryBtnColor"
        shape="round"
        onClick={showModal}
      >
        <SearchOutlined />
        &nbsp;{labelConfig.searchParams}
      </Button>
      <Modal
        title="Search Journal Entries"
        open={isModalOpen}
        okText="Search"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={1000}
        modalRender={(dom) => (
          <Form layout="vertical" form={form} onFinish={onSubmit}>
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          {/* <Text>RENDER TABLE LIST HERE</Text> */}
          <Row style={{ justifyContent: "space-betwen" }}>
            <Divider orientation="left" orientationMargin="0">
              {/* <Text level={3} style={{ margin: 0, marginBottom: 0 }}> */}
              {labelConfig.generalInfo}
              {/* </Text> */}
            </Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="officeId"
                label={<Text>{labelConfig.branch}</Text>}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  onChange={(e) => console.log(e)}
                  options={officeData}
                  showSearch
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.branch)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="glAccountId"
                label={<Text>{labelConfig.account}</Text>}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  options={accountData}
                  showSearch
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.account)}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="date"
                label={<Text>{labelConfig.dateRange}</Text>}
              >
                <RangePicker style={{ width: "100%", height: 35 }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="manualEntriesOnly"
                label={<Text>{labelConfig.filter}</Text>}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase(),
                    )
                  }
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.filter,
                    "select",
                  )}
                  options={staticConfig.filterOptions}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="transactionId"
                label={<Text>{labelConfig.transactionId}</Text>}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.transactionId,
                  )}
                  // style={styles.ofInputFieldNumber}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(SearchJournalEntry);
